//#region src/pinata_table_tracker_result.ts
var PinataTableTrackerResult = /* @__PURE__ */ function(PinataTableTrackerResult) {
	PinataTableTrackerResult["Success"] = "success";
	PinataTableTrackerResult["Failure"] = "failure";
	return PinataTableTrackerResult;
}(PinataTableTrackerResult || {});
//#endregion
export { PinataTableTrackerResult };

//# sourceMappingURL=pinata_table_tracker_result.js.map